import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import './Projects.css';

function Projects() {
  const revealRef = useScrollReveal();
  const projects = [
    {
      id: 1,
      title: "Classic Home Mobile Barber",
      description: "Professional business website for a mobile barbershop featuring real-time availability calendar, cloud sync with Firebase, password-protected admin panel, and PWA support.",
      techStack: ["HTML5", "CSS3", "JavaScript", "Firebase"],
      liveUrl: "#",
      githubUrl: "https://github.com/Stanleyashz/barber",
      featured: true
    },
    {
      id: 2,
      title: "E-Commerce Store",
      description: "Full-stack e-commerce application with product browsing, cart management, user authentication, and order processing. Built with the MERN stack with React frontend on Vercel and Express API on Render.",
      techStack: ["MongoDB", "Express.js", "React", "Node.js"],
      liveUrl: "https://e-commerce-store-eight-orcin.vercel.app",
      githubUrl: "https://github.com/Stanleyashz/E-commerce-store",
      featured: true
    },
    {
      id: 3,
      title: "Microservices Architecture",
      description: "Cloud-native application demonstrating microservices patterns with an API Gateway routing to independent Inventory, Order, and Product services. Each service is containerized with Docker for consistent deployment.",
      techStack: ["Java", "Docker", "API Gateway", "REST APIs", "Microservices"],
      githubUrl: "https://github.com/Stanleyashz/InClassExercise2",
      inProgress: true,
      featured: false
    },
  ];

  return (
    <section className="projects reveal" id="projects" ref={revealRef}>
      <div className="container">
        <span className="section-label">{"// Projects"}</span>
        <h2 className="section-title">Featured Work</h2>

        <div className="projects-grid">
          {projects.map((project) => (
            <article key={project.id} className={`project-card ${project.featured ? 'featured' : ''}`}>
              {project.inProgress && (
                <span className="project-badge in-progress-badge mono">In Progress</span>
              )}
              {project.featured && (
                <span className="project-badge featured-badge mono">Featured</span>
              )}

              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>

                <div className="project-tech">
                  {project.techStack.map((tech) => (
                    <span key={tech} className="tech-tag mono">{tech}</span>
                  ))}
                </div>

                <div className="project-links">
                  {project.liveUrl && (
                    <a
                      href={project.liveUrl}
                      className="project-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                        <polyline points="15 3 21 3 21 9"/>
                        <line x1="10" y1="14" x2="21" y2="3"/>
                      </svg>
                      Live Demo
                    </a>
                  )}
                  {project.githubUrl && (
                    <a
                      href={project.githubUrl}
                      className="project-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                      </svg>
                      Source
                    </a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="projects-cta">
          <a
            href="https://github.com/Stanleyashz"
            className="btn btn-secondary"
            target="_blank"
            rel="noopener noreferrer"
          >
            View All Projects on GitHub
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M7 17L17 7M17 7H7M17 7V17"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Projects;
